import { FetchResult } from '@apollo/client';
import { defaultErrorsHandler } from '@pendwa/common-browser/core/apollo/utils.js';
import { logger } from '@pendwa/common-browser/core/logger/index.js';
import React from 'react';
import { googlePlatformLibraryLogout } from '../../../core/googlePlatformLibrary/index.js';
import { HooksAccountLogoutMutation } from '../../../generated/graphql.js';
import { useAccountLogoutGraphql } from '../../../hooks/user/logoutGraphql.js';

export interface IPropsLogout {
  handleSuccess: (result: FetchResult<HooksAccountLogoutMutation>) => void;
}

export const Logout: React.FC<IPropsLogout> = (props) => {
  const { result: mutation_result, doAction } = useAccountLogoutGraphql();

  React.useEffect(() => {
    defaultErrorsHandler(mutation_result.error);
  }, [mutation_result]);

  const executeAction = async () => {
    const action_result = await doAction();

    if (!action_result.errors && action_result.data?.accountLogout?.data?.status) {
      try {
        await googlePlatformLibraryLogout();
      } catch (error) {
        logger.error(
          new Error('failed to log out google', {
            cause: error,
          })
        );
      }

      setTimeout(() => props.handleSuccess(action_result), 0);
    }
  };

  React.useEffect(() => {
    executeAction();
  }, []);

  return null;
};
